import React from 'react';
import { connect } from 'react-redux';

import Page from '../../../page.jsx';
import ReceiptLink from '../../../receiptLink.jsx';
import { data as agreementDataPropTypes } from '../../../agreementPropTypes.js';
import { data as paymentDataPropTypes } from '../../../paymentPropTypes.js';
import withdrawalPropTypes from '../../../withdrawalPropTypes.js';
import formatOreToKroner from '../../../../lib/formatOreToKroner';
import FeedbackLink, { BUYER_SAD } from '../../../feedbackLink.jsx';

function calcDiscount(agreement, payment) {
    return payment.discount + (agreement.fee - payment.fee);
}

const DiscountApprovedWithAutomaticWithdrawalDetails = ({
    agreement,
    payment,
}) => (
    <div>
        <p>
            Du fikk et prisavslag på{' '}
            {formatOreToKroner(calcDiscount(agreement, payment))}. Du vil se
            pengene på konto mellom 1&ndash;3 virkedager etter avslaget ble
            gitt.
        </p>

        <div className="centerify">
            <div className="r-phl r-ptl">
                <ReceiptLink payment={payment} />
                <FeedbackLink type={BUYER_SAD} />
            </div>
        </div>
    </div>
);

DiscountApprovedWithAutomaticWithdrawalDetails.propTypes = {
    agreement: agreementDataPropTypes.isRequired,
    payment: paymentDataPropTypes.isRequired,
};

const DiscountApprovedWithoutAutomaticWithdrawalDetails = ({
    agreement,
    payment,
}) => (
    <div>
        <p>
            Du har fått tilbake{' '}
            {formatOreToKroner(calcDiscount(agreement, payment))} på din{' '}
            <a href={payment.spidWalletUrl}>SPiD Cash-konto</a>.
        </p>

        <div className="centerify">
            <div className="r-phl r-ptl">
                <a
                    href={payment.withdrawFlowSpidUrl}
                    className="button r-mbl primary fullwidth"
                >
                    Overfør pengene til din bankkonto
                </a>

                <ReceiptLink payment={payment} />
                <FeedbackLink type={BUYER_SAD} />
            </div>
        </div>
    </div>
);

DiscountApprovedWithoutAutomaticWithdrawalDetails.propTypes = {
    agreement: agreementDataPropTypes.isRequired,
    payment: paymentDataPropTypes.isRequired,
};

const DiscountApprovedDetails = ({ agreement, payment, withdrawal }) => (
    <Page heading="Dere har blitt enige om et prisavslag, og handelen er ferdig">
        {withdrawal ? (
            <DiscountApprovedWithAutomaticWithdrawalDetails
                agreement={agreement}
                payment={payment}
            />
        ) : (
            <DiscountApprovedWithoutAutomaticWithdrawalDetails
                agreement={agreement}
                payment={payment}
            />
        )}
    </Page>
);

DiscountApprovedDetails.propTypes = {
    agreement: agreementDataPropTypes.isRequired,
    payment: paymentDataPropTypes.isRequired,
    withdrawal: withdrawalPropTypes,
};

function mapStateToProps(state) {
    return {
        agreement: state.agreement.data,
        payment: state.payment.data,
        withdrawal: state.withdrawal,
    };
}

export default connect(mapStateToProps)(DiscountApprovedDetails);



// WEBPACK FOOTER //
// ./safeTrade/buyer/resolution/statusDetails/discountApprovedDetails.jsx